__turbopack_context__.v({
  "description": "intro-module-scss-module___vMyUa__description",
  "intro": "intro-module-scss-module___vMyUa__intro",
  "introAnimatedTitle": "intro-module-scss-module___vMyUa__introAnimatedTitle",
});
